var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#333333",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "all") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,49.88C-0.09,22.09,23.24-.74,51.38,0c26,0.7,48.73,22.17,48.62,50.25A50,50,0,0,1,0,49.88Zm73.88,0.88a13.14,13.14,0,0,0-2.27-2.43q-15-8.9-30.1-17.66C39,29.2,37,30.23,37,33.1q-0.15,17.74,0,35.48c0,2.89,2,4,4.5,2.53q15.22-8.8,30.32-17.8C72.56,52.84,73,51.82,73.89,50.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.99f1a69edadde242106555c3312030a2.svg";
export { ForwardRef as ReactComponent };